// ✅ 自动从 Instagram API 拉取内容并渲染 Swiper 轮播

window.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("ugc-wall");
  if (!container) return;

  const token = "EAAJvLZBwZCaY4BO7FuE0FBN58UqX2IZB914cACjXK6SjMoRm3TlUWVl2gUMSu9v8TZBN29fkSgO37OSfQn2pv4nzRzm4bp5oOgheJIFaU16tGWOCUIQztheDqZBIyALTBNKNqcFVzxM3JwWdZBgprWSQaJyNZAVS4pqBZAGtUJbYGSZAkhgz4XL4yAGwABK7nZCwLW2gZDZD";
  const igId = "17841400020857067";

  const url = `https://graph.facebook.com/v18.0/${igId}/media?fields=id,media_url,caption,permalink,timestamp,media_type&access_token=${token}`;

  fetch(url)
    .then(res => res.json())
    .then(res => {
      const ugcData = (res.data || []).map(item => ({
  media_url: item.media_url,
  caption: item.caption || "",
  creator: "@lancwl418",
  product_link: item.permalink,
  media_type: item.media_type
}));
      renderSlider(ugcData);
    })
    .catch(err => {
      container.innerHTML = "<p style='color:red'>加载 Instagram 内容失败</p>";
      console.error("Instagram API Error:", err);
    });

  // 加载 Swiper CSS & JS（CDN）
  const swiperCss = document.createElement("link");
  swiperCss.rel = "stylesheet";
  swiperCss.href = "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css";
  document.head.appendChild(swiperCss);

  const swiperJs = document.createElement("script");
  swiperJs.src = "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js";
  document.body.appendChild(swiperJs);

  function renderSlider(data) {
    container.innerHTML = `
      <div class="swiper">
        <div class="swiper-wrapper">
          ${data.map(item => `
  <div class="swiper-slide">
    ${
      item.media_type === "VIDEO"
        ? `<video controls muted style="width:100%; border-radius: 8px;">
             <source src="${item.media_url}" type="video/mp4" />
           </video>`
        : `<img src="${item.media_url}" style="width:100%; border-radius: 8px;" />`
    }
    <p style="margin: 8px 0;"><strong>${item.creator}</strong>: ${item.caption}</p>
    <a href="${item.product_link}" target="_blank">查看原帖</a>
  </div>
`).join("")}
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    `;

    new Swiper(".swiper", {
  loop: true,
  slidesPerView: 5,            // 一次显示 5 个
  spaceBetween: 16,            // 每个卡片间距
  pagination: { el: ".swiper-pagination" },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {               // 响应式支持（可选）
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
    1280: {
      slidesPerView: 5,
    }
  }
});
  }
});
